<template>
  <div class="approval-my-initiated">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-button type="primary" icon="el-icon-plus" v-if="funcView.invoiceBody_receive_add" @click="onAddBody()">{{ $t('Common.com_add') }}</el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right;">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('fms_recipient-table.ssgsnsrsbhqymc')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table height="100%" tableCode="invoiceRecipient"  :data="tableList" :index="true" @filter="filterChange" @sort="sortChange"  @column="setColumn" :slots="['action']">
        <template v-slot:action="scope">
          <span></span>
          <el-button @click="onEditBody(scope.row)" v-if="funcView.invoiceBody_receive_edit" type="text" size="mini">{{ $t('Common.com_edit') }}</el-button>
          <el-button @click="onDeleteBody(scope.row.partnerInvoiceId)" v-if="funcView.invoiceBody_receive_delete" type="text" size="mini">{{ $t('Common.com_delete') }}</el-button>
          <el-button @click="onDefault(scope.row.partnerInvoiceId)" type="text" size="mini" v-if="funcView.invoiceBody_receive_default && scope.row.isDefault === 0">
            {{ funcView.invoiceBody_default }}
          </el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <!-- 新增编辑发票主体 -->
    <body-item-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getTableList"></body-item-dialog>
  </div>
</template>

<script>
/** 我发起的 */

import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
import bodyItemDialog from './body_recipientItem_dialog.vue';

export default {
  mixins: [resetFormSearchMixins],
  components: {
    bodyItemDialog,
  },
  data() {
    return {
      tableCode: 'invoiceRecipient',
      formSearch: {
        invoiceOrgType: 1, // 工发票方类型 0-开票方，1-受票方 【默认开票方】
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
      },
      tableList: [],
      totalRows: 0,

      dialogVisible: false,
      dialogModel: {},
    };
  },
  props: {
    workflowClass: {
      type: Number,
    },
  },
  methods: {
    onAddBody: function () {
      this.dialogModel.type = 'add';
      this.dialogModel.title = this.$t('fms_recipient-table.xzfpzt');
      this.dialogVisible = true;
    },
    onEditBody: function (row) {
      this.dialogModel.type = 'edit';
      this.dialogModel.title = this.$t('fms_recipient-table.bjfpzt');
      this.dialogModel.data = row;
      this.dialogVisible = true;
    },
    onDeleteBody: function (id) {
      const tips = this.$t('fms_recipient-table.qdyscdqxzdfbztm');
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.crmPartnerInvoiceDelete}/${id}`).then(() => {
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    onDefault: function (id) {
      const tips = this.$t('fms_recipient-table.qdyjdqxzdfbztswmrm');
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.crmPartnerInvoiceUpdateIsDefault}/${id}`).then(() => {
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    getTableList() {
      this.$getJSON(apis.crmPartnerInvoicePage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
  },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);

    this.getTableList();
    this.getFuncView('/invoice/invoiceBody');
  },
};
</script>

<style lang="scss">
.approval-my-initiated {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>
